// SubscriptionPayment.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Notiflix from 'notiflix';
import { endpoint } from './endpoint';
import {useUser} from "./UserContext";

const SubscriptionPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { plan } = location.state || {}; // Safely access state
  const {user} = useUser();
  
  useEffect(() => {
    // Check if plan is properly passed
    if (!plan || !plan.priceInCents) {
      Notiflix.Report.failure('Error', 'Invalid plan details.', 'OK', () => {
        navigate('/dashboard');
      });
      return;
    }

    const yoco = new window.YocoSDK({
      publicKey: 'pk_test_ed3c54a6gOol69qa7f45', // Replace with your live public key when in production
    });

    const showSubscriptionPopup = () => {
      yoco.showPopup({
        amountInCents: plan.priceInCents, // Use the correct amount from plan
        currency: 'ZAR',
        name: `Subscribe to ${plan.name}`,
        description: `First payment for ${plan.name} plan subscription`,
        callback: function (result) {
          if (result.error) {
            Notiflix.Notify.failure('Error occurred: ' + result.error.message);
            navigate('/dashboard');
          } else {
            // Handle successful initial payment here
            handleSubscriptionSuccess(result.id);
          }
        },
      });
    };

    const handleSubscriptionSuccess = (paymentToken) => {
      fetch(`${endpoint}/gymapp/setupSubscription.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          planName: plan.name,
          priceInCents: plan.priceInCents,
          paymentToken: paymentToken,
          user: user,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status == "success") {
            Notiflix.Report.success('Subscription setup successful!', 'You will be billed monthly.', 'OK', () => {
              navigate('/dashboard');
            });
          } else {
            Notiflix.Report.failure('Subscription setup failed', data.message, 'Try Again', () => {
              navigate('/dashboard');
            });
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          Notiflix.Report.failure('Error', 'Something went wrong. Please try again.', 'OK', () => {
            navigate('/dashboard');
          });
        });
    };

    showSubscriptionPopup(); // Trigger the payment popup on component load
  }, [plan, user, navigate]);

  return null; // No UI needed as the payment popup will be handled by YOCO
};

export default SubscriptionPayment;
